export class RedshiftCluster {
    'name';
    'id';
    'databases';
    'roleArns';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "databases",
            "baseName": "databases",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "roleArns",
            "baseName": "roleArns",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RedshiftCluster.attributeTypeMap;
    }
    constructor() {
    }
}
